import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export const MessageUserServiceInitialized = 'MessageUserServiceInitialized';
// export const MessageSelectedVoiceOnChange = 'MessageSelectedVoiceTypeOnChange';
// export const MessageDisablePremium = 'MessageDisablePremium';
/* theme */
export const MessageThemeChange = 'MessageThemeChange';

/* single-page */
export const MessageReadingPageStateChanged = 'MessageReadingPageStateChanged';
/* reader */
export const MessageOnPlayEnd = 'MessageOnPlayEnd';
export const MessageOnLoading = 'MessageOnLoading';
export const MessageOnPlay = 'MessageOnPlay';
export const MessageOnStop = 'MessageOnStop';
export const MessagePauseButtonOnClick = 'MessagePauseButtonOnClick';
export const MessageOnReaderError = 'MessageOnReaderError';
export const MessageOnSpeechEnd = 'MessageOnSpeechEnd';
export const MessageOnFirstPlay = 'MessageOnFirstPlay';
export const MessageStopReader = 'MessageStopReader';
export const MessageStartReader = 'MessageStartReader';
export const MessageSetCC = 'MessageSetCC';
export const MessageToggleCC = 'MessageToggleCC';
export const MessageChangeCCMode = 'MessageChangeCCMode';
export const MessageCloseCC = 'MessageCloseCC';
export const MessageToggleTextview = 'MessageToggleTextview';
export const MessageCloseTextview = 'MessageCloseTextview';
export const MessageHighlightWord = 'MessageHighlightWord';
export const MessageHighlightSen = 'MessageHighlightSen';
export const MessageResetTtsError = 'MessageResetTtsError';
export const MessageToggleReading = 'MessageToggleReading';
export const MessageInvalidReaderType = '  MessageInvalidReaderType';
export const MessageScrollToSentence = 'MessageScrollToSentence';
// export const MessageSetCCWordIndex = 'MessageSetCCWordIndex';

/* voice */
export const MessageOpenVoiceList = 'MessageOpenVoiceList';
export const MessageCloseVoiceList = 'MessageCloseVoiceList';
export const MessageFreeVoicesReady = 'MessageFreeVoicesReady';
export const MessagePremVoicesReady = 'MessagePremVoicesReady';
export const MessagePlusVoicesReady = 'MessagePlusVoicesReady';
export const MessageClonedVoicesReady = 'MessageClonedVoicesReady';
export const MessageSelectedVoiceTypeOnChange = 'MessageSelectedVoiceTypeOnChange';
export const MessageVoiceOnChange = 'MessageVoiceOnChange';
export const MessageSelectVoiceOfLang = 'MessageSelectVoiceOfLang';

/* tts text */
export const MessageTextSourceChanged = 'MessageTextSourceChanged';

/* progress bar */
export const MessageJumpToTime = 'MessageJumpToTime';
export const MessageSetTotalTime = 'MessageSetTotalTime';
export const MessageSetTotalTimeFinish = 'MessageSetTotalTimeFinish';
export const MessageJumpToPosition = 'MessageJumpToPosition';
// for app lock screen
export const MessageSetTotalTimeForInput = 'MessageSetTotalTimeForInput';
export const MessageSetSentenceTime = 'MessageSetSentenceTime';
/* input */
export const MessageShareOpened = 'MessageShareOpened';
export const MessageProcessInputAndPlay = 'MessageProcessInputAndPlay';
export const MessageCordovaPaste = 'MessageCordovaPaste';
export const MessageToggleTextReading = 'MessageToggleTextReading';
export const MessageOpenTextFile = 'MessageOpenTextFile';
export const MessageSetTextFileId = 'MessageSetTextFileId';
export const MessageCreateNewTextFile = 'MessageCreateNewTextFile';
export const MessageToggleReadingUpload = 'MessageToggleReadingUpload';

/* pdf */
export const MessagePdfStateChanged = 'MessagePdfStateChanged';
export const MessagePagePromiseReady = 'MessagePagePromiseReady';
export const MessageJumpToPage = 'MessageJumpToPage';
export const MessagePdfPageUpdated = 'MessagePdfPageUpdated';
export const MessageUpdateMargin = 'MessageUpdateMargin';
export const MessageHasSkippables = 'MessageHasSkippables';
export const MessagePDFLoading = 'MessagePDFLoading';
export const MessageUrlToPdf = 'MessageUrlToPdf';
export const MessageOpenPDFTextFilteringOptions = 'MessageOpenPDFTextFilteringOptions';
export const MessageHeaderFooterDetected = 'MessageHeaderFooterDetected';
export const MessageResetHeaderFooterDetected = 'MessageResetHeaderFooterDetected';
export const MessageDragPageIcon = "MessageDragPageIcon";
export const MessageSetPDFViewerZoomEnded = "MessageSetPDFViewerZoomEnded";

// pe
export const MessagePEListReady = 'MessagePEListReady';
export const MessagePEListUpdated = 'MessagePEListUpdated';
export const MessageWaitingForPEList = 'MessageWaitingForPEList';

/* settings */
export const MessageSettingsReady = 'MessageSettingsReady';
export const MessageIsDyslexicChanged = 'MessageIsDyslexicChanged';
export const MessageIsTextSpacingChanged = 'MessageIsTextSpacingChanged';
export const MessageIsHighlightWordChanged = 'MessageIsHighlightWordChanged';
export const MessageBeHighlightedChanged = 'MessageBeHighlightedChanged'
export const MessageTextSettingsUpdated = 'MessageTextSettingsUpdated';
export const MessagePdfSkippablesChanged = 'MessagePdfSkippablesChanged';
export const MessageIsCCChanged = 'MessageIsCCChanged';
export const MessageIsAutoScrollChanged = 'MessageIsAutoScrollChanged';
export const MessageOpenSpeedSlider = 'MessageOpenSpeedSlider';
export const MessageDisablePremium = 'MessageDisablePremium';
export const MessageSpeedOnChange = 'MessageSpeedOnChange';

/* network */
export const MessageOnOnline = 'MessageOnOnline';
export const MessageOnOffline = 'MessageOnOffline';


/* Upload */
export const MessageUploadFile = 'MessageUploadFile';
export const MessageOnFinishedUpload = 'MessageOnFinishedUpload';
export const MessageUploadLocalFileFinish = 'MessageUploadLocalFileFinish';
export const MessageNoSigninUploadLocalFileOk = 'MessageNoSigninUploadLocalFileOk';
export const MessageUploadRemotePdf = 'MessageUploadRemotePdf';
export const MessageUploadSingleOCR = 'MessageUploadSingleOCR';
export const MessageCloseDialog = 'MessageCloseDialog';
export const MessageCancelUploadS3 = 'MessageCancelUploadS3';
export const MessageUploadS3Finish = 'MessageUploadS3Finish';
export const MessageCloseUploadingDialog = 'MessageCloseUploadingDialog';
export const MessageCancelUploadFile = 'MessageCancelUploadFile';

/* tts */
export const MessageTtsLimit = 'MessageTtsLimit';
export const MessageTtsWaitingForLicense = 'MessageTtsWaitingForLicense';
export const MessageCordovaOfflineMode = 'MessageCordovaOfflineMode';
export const MessageCordovaOnlineTTSError = 'MessageCordovaOnlineTTSError';
export const MessageCordovaOnlineTTSPreview = 'MessageCordovaOnlineTTSPreview';

/* billing */
export const MessageLicenseAndCardUpdated = 'MessageLicenseAndCardUpdated';
export const MessageLicenseLoading = 'MessageLicenseLoading';
export const MessageCheckNeedForComm = 'MessageCheckNeedForComm'

/* ocr */
export const MessageOCR = 'MessageOCR';

/* convert */
export const MessageConvertBtnOnClick = 'MessageConvertBtnOnClick';
export const MessageConvert = 'MessageConvert';
export const MessageConvertCancelled = 'MessageConvertCancelled';
export const MessageConvertWaitingForLicense = 'MessageConvertWaitingForLicense';
export const MessageConvertProgress = 'MessageConvertProgress';
export const MessageUpdateAudioList = 'MessageUpdateAudioList';
export const MessageAudiosUpdated = 'MessageAudiosUpdated';
export const MessageDocConvertFailed = 'MessageDocConvertFailed';
export const MessageUseCloudConvert = 'MessageUseCloudConvert';
export const MessageCloudConvertFailed = 'MessageCloudConvertFailed';

export const MessageSWLicenseUpdated = 'MessageSWLicenseUpdated';
export const MessageUserUpdated = 'MessageUserUpdated';

// user info
export const MessageUserInfoReady = 'MessageUserInfoReady';
export const MessageUserInfoRemoved = 'MessageUserInfoRemoved';
export const MessagePromptOpened = 'MessagePromptOpened';
export const MessageRequireLogin = 'MessageRequireLogin';
export const MessageSendEmail = 'MessageSendEmail';
export const MessageEmailSent = 'MessageEmailSent';
export const MessageCheckOut = 'MessageCheckOut';
export const MessageShowUpgrade = 'MessageShowUpgrade';

// sw
export const MessageGoToSWAccountInfo = 'MessageGoToSWAccountInfo';

// Last Read
export const MessageLastReadNewPage = 'MessageLastReadNewPage';
export const MessageLastReadDeleted = 'MessageLastReadDeleted';
export const MessageLastReadUpdated = 'MessageLastReadUpdated';
export const MessageCurrentlyOpenedFileDeleted = 'MessageCurrentlyOpenedFileDeleted';
export const MessagePdfRemoveBorders = 'MessagePdfRemoveBorders';

// Indexed Db
export const MessageIndexedDBInitiated = 'MessageIndexedDBInitiated';

export const MessageLogout = 'MessageLogout';
export const MessageLogin = 'MessageLogin';
export const MessageLoginOnClick = 'MessageLoginOnClick';
export const MessageLoginDev = 'MessageLoginDev';
export const MessageCognitoInit = 'MessageCognitoInit';
export const MessageAmplifyInit = 'MessageAmplifyInit';

// File services //
export const MessageDownloadProgress = 'MessageDownloadProgress';
export const MessageCancelDownload = 'MessageCancelDownload';
export const MessageOpenRemotePdf = 'MessageOpenRemotePdf';
export const MessageUploadingFile = 'MessageUploadingFile';
export const MessagePdfContentDoneExtracted = 'MessagePdfContentDoneExtracted';
export const MessageSaveCurFileIdInStorage = 'MessageSaveCurFileIdInStorage';
export const MessageRemoveCurFileIdFromStorage = 'MessageRemoveCurFileIdFromStorage';

// bookmark
export const MessageGoToBookmark = 'MessageGoToBookmark';
export const MessageSetBookmarks = 'MessageSetBookmarks';
export const MessageAddBookmark = 'MessageAddBookmark';
export const MessageCloseTOCMenu = 'MessageCloseTOCMenu';

/* cordova */
export const MessageCordovaGetAppVersion = 'MessageCordovaGetAppVersion';

/* UserMenu Library edu */
export const MessageEduGroupDataChanged = 'MessageEduGroupDataChanged';
export const MessageListLoading = 'MessageListLoading';
export const MessageImageLoading = 'MessageImageLoading';
export const MessageOpenLibrary = 'MessageOpenLibrary';
export const MessageOpenPE = 'MessageOpenPE';
export const MessageOpenBilling = 'MessageOpenBilling';
export const MessageOpenProfile = 'MessageOpenProfile';
export const MessageOpenSettings = 'MessageOpenSettings';
export const MessageEduFilesUpdated = 'MessageEduFilesUpdated';
export const MessageResetReader = 'MessageResetReader';
export const MessageCloseFolder = 'MessageCloseFolder';

/* home */
export const MessageShowDragAndDropScreen = 'MessageShowDragAndDropScreen';

/* miniboard*/
export const MessageMiniHotKeyPlay = 'MessageMiniHotKeyPlay';
export const MessageMiniHotKeyPre = 'MessageMiniHotKeyPre';
export const MessageMiniHotKeyNext = 'MessageMiniHotKeyNext';
export const MessageMiniHotKeyVolumeUp = 'MessageMiniHotKeyVolumeUp';
export const MessageMiniHotKeyVolumeDown = 'MessageMiniHotKeyVolumeDown';
/* bottomsheet*/
export const MessageBottomSheetAction = 'MessageBottomSheetAction';
// export const MessageAddFromWebpage = 'MessageAddFromWebpage';
// export const MessageAddFromPaste = 'MessageAddFromPaste';
// export const MessageAddToLibrary = 'MessageAddToLibrary';


// Library
export const MessageLibraryRefreshed = 'MessageLibraryRefreshed';
export const MessageToggleSelectionMode = 'MessageToggleSelectionMode';
export const MessageEnableSelectionMode = 'MessageEnableSelectionMode';
export const MessageDisableSelectionMode = 'MessageDisableSelectionMode';
export const MessageFileAction = 'MessageFileAction';
export const MessageCreatingLibraryFolder = 'MessageCreatingLibraryFolder';
export const MessageRefreshLibraryFiles = 'MessageRefreshLibraryFiles';
export const MessageDeleteFiles = 'MessageDeleteFiles';
export const MessageRenameFile = 'MessageRenameFile';
export const MessageDeleteCurText = 'MessageDeleteCurText';
export const MessageOpenWebpageConvert = 'MessageOpenWebpageConvert';
export const MessageOpenAccountMenu = 'MessageOpenAccountMenu';
export const MessageLibraryUiElement = 'MessageLibraryUiElement';
export const MessageDataSourceUpdated = 'MessageDataSourceUpdated';
export const MessageSearchPanelToggle = 'MessageSearchPanelToggle';
export const MessageEnterFolder = "MessageEnterFolder";
export const MessageChangeLibraryType = "MessageChangeLibraryType";
export const MessageAddedWebpage = 'MessageAddedWebpage';
export const MessageOpenCordovaDocuments = 'MessageOpenCordovaDocuments';
export const MessageOpenCameraScan = 'MessageOpenCameraScan';
export const MessageOpenPhotoLibrary = 'MessageOpenPhotoLibrary';
export const MessageBackToLibrary = 'MessageBackToLibrary';
export const MessageDocumentOpenError = 'MessageDocumentOpenError';
export const MessageLibraryEmptyError = 'MessageLibraryEmptyError';

// cordova
export const MessageCordovaAddSharedFile = 'MessageCordovaAddSharedFile';
export const MessageCordovaOpenSharedFile = 'MessageCordovaOpenSharedFile';
export const MessageCoerdovaTTSWordRange = 'MessageCoerdovaTTSWordRange';
export const MessageCordovaCheckVersion = 'MessageCordovaCheckVersion';
export const MessageCordovaStop = 'MessageCordovaStop';
export const MessageCordovaCancelAudioDownload = 'MessageCordovaCancelAudioDownload';
export const MessageCordovaAudioDownloadHasBeenCancelled = 'MessageCordovaAudioDownloadHasBeenCancelled';
export const MessageCordovaLoadingDownloadMP3 = 'MessageCordovaLoadingDownloadMP3';
export const MessageCordovaIAPProcessing = 'MessageCordovaIAPProcessing';
export const MessageNeedUpdate = "MessageNeedUpdate";
export const MessageCordovaRestore = 'MessageCordovaRestore';
export const MessageERR_PAGE_UNDEFINED = 'MessageERR_PAGE_UNDEFINED';
export const MessageCordovaAndroidStore = 'MessageCordovaAndroidStore';
export const MessageCordovaInAppRating = 'MessageCordovaInAppRating';
export const MessageTokenHasExpired = 'MessageTokenHasExpired';
export const MessageCheckTokenHasExpired = 'MessageCheckTokenHasExpired';
export const MessageSleepTimer = 'MessageSleepTimer';
export const MessageCordovaSharedText = 'MessageCordovaSharedText';
export const MessageCordovaAppStore = 'MessageCordovaAppStore';

//lock screen notification
export const MessageCordovaNotificationClick = 'MessageCordovaNotificationClick';
export const MessageCordovaBackground = 'MessageCordovaBackground';
export const MessageCordovaPluginReady = 'MessageCordovaPluginReady';
// export const MessageUrlTextToInputBox = 'MessageUrlTextToInputBox';
export const MessagePageInactivity = 'MessagePageInactivity';
export const MessageCordovaCloseNotification = 'MessageCordovaCloseNotification';

/* Other */
export const MessageBeforeUnload = 'MessageBeforeUnload';
export const MessageClearInputAndPaste = 'MessageClearInputAndPaste';
export const MessageWindowOnFocus = 'MessageWindowOnFocus';
export const MessageHideReading = 'MessageHideReading';

// app initial
export const MessageAppInitialStep = 'MessageAppInitialStep';
export const MessageNewAIVoicesNotification = 'MessageNewAIVoicesNotification';

// pw-2024
// export const MessageOpenTestPdfFile = 'MessageOpenTestPdfFile';
// camera scan and image ocr
export const MessageImageChoosed = 'MessageImageChoosed';

export const MessageChatPdf = 'MessageChatPdf';
export const MessageChatPdfUploaded = 'MessageChatPdfUploaded';
export const MessageChatPdfUploading = 'MessageChatPdfUploading';
export const MessageChatPdfError = 'MessageChatPdfError';
export const MessageChatPdfAnswer = 'MessageChatPdfAnswer';
export const MessageOnlinePlayTextsError = "MessageOnlinePlayTextsError";
export const MessageOnlinePlayTextsStop = 'MessageOnlinePlayTextsStop';
export const MessageClickSentece = "MessageClickSentece";
export const MessageOnPreviewEnd = 'MessageOnPreviewEnd';

export const MessageRestoreLicense = 'MessageRestoreLicense';
export const MessageLoginExpired = 'MessageLoginExpired';

export const MessagePdfExport = 'MessagePdfExport';
export const MessageAnnotationFileDownloadStart = 'MessageAnnotationFileDownloadStart';
export const MessageAnnotationFileDownloaded = 'MessageAnnotationFileDownloaded';
export const MessageAnnotationDownloadFailed = 'MessageAnnotationDownloadFailed';
export const MessageAnnotationListNeedRefresh = 'MessageAnnotationListNeedRefresh';
export const MessageAnnotationEditFailed = 'MessageAnnotationEditFailed';

// voice cloning
export const MessageShowReactivatingVoiceDialog = 'MessageShowReactivatingVoiceDialog';
export const MessageReactivatingVoiceDialogClosed = 'MessageReactivatingVoiceDialogClosed';
export const MessageCloseReactivatingVoiceDialog = 'MessageCloseReactivatingVoiceDialog';

export const MessageGetAllAnnotationDivs = 'MessageGetAllAnnotationDivs';
export const MessageAddAnnotation = 'MessageAddAnnotation';

// install apps
export const MessageShowAppInstallPopup = 'MessageShowAppInstallPopup';
export const MessageUserMetadataUpdated = 'MessageUserMetadataUpdated';

// export const MessageShowDebugInfo = 'MessageShowDebugInfo';
export interface Message {
  name: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  private subject = new Subject<any>();
  constructor() { }

  sendMessage(message: Message) {
    console.log("sendMessage", message);
    this.subject.next(message);
  }

  clearMessage() {
    this.subject.next(null);
  }

  getMessage(): Observable<Message> {
    return this.subject.asObservable();
  }
}
